import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';

const CONTENT = {
  it: {
    pageTitle: 'Cookie Policy - ALLMX',
    pageDesc: 'Cookie Policy di ALLMX.it',
    back: 'Indietro',
    title: 'Gestione dei Cookies',
    subtitle: "Informativa sull'uso dei cookie",
    lastUpdate: 'Ultimo aggiornamento',
    locale: 'it-IT',
    intro: {
      greeting: 'Gentile visitatore,',
      text: 'Questo sito web desidera fornirle alcune informazioni sui cookies gestiti accedendo all\'indirizzo <strong>www.allmx.it</strong> nel rispetto della Direttiva sulle Comunicazioni Elettroniche 2009/136/CE, della direttiva 2002/58/CE relativa al trattamento dei dati personali e alla tutela della vita privata nel settore delle comunicazioni elettroniche e del Provvedimento a carattere generale del 8 maggio 2014 del Garante per la protezione dei dati personali.'
    },
    what: {
      title: 'Che cosa sono i cookies',
      p1: 'I cookies sono piccoli file di testo che i siti visitati dagli utenti inviano ai loro terminali, generalmente si trovano sulla directory del browser, ove vengono memorizzati per essere poi ritrasmessi agli stessi siti alla visita successiva. Questi permettono a chi gestisce il sito web di fare cose utili, per esempio, migliorare l\'esperienza di navigazione ed il funzionamento del sito, rendendo le interazioni più veloci e personalizzate, consentono al gestore di un sito di sapere se un computer ha visitato il sito web in precedenza o di memorizzare gli articoli presenti nel carrello, in caso di sito e-commerce.',
      p2: 'Il cookie non ha di per sé natura personale, ma potrebbe essere collegato a informazioni personali, in questo ultimo caso necessitano pertanto del consenso all\'uso.'
    },
    purpose: {
      title: 'Tipologie di cookies in base alle finalità',
      technical: {
        title: 'Cookies tecnici',
        p1: 'Sono quelli utilizzati al solo fine di "effettuare la trasmissione di una comunicazione su una rete di comunicazione elettronica o nella misura strettamente necessaria al fornitore di un servizio della società dell\'informazione esplicitamente richiesto dall\'abbonato o dall\'utente a erogare tale servizio".',
        p2: 'Essi non vengono utilizzati per scopi ulteriori e sono normalmente installati direttamente dal titolare o gestore del sito web. Possono essere suddivisi in:',
        list: [
          '<strong>cookie di navigazione o di sessione</strong>, che garantiscono la normale navigazione e fruizione del sito web, non vengono memorizzati in modo persistente sul computer dell\'utente e svaniscono con la chiusura del browser;',
          '<strong>cookie analytics</strong>, assimilati ai cookie tecnici laddove utilizzati direttamente dal gestore del sito per raccogliere informazioni, in forma aggregata, sul numero degli utenti e su come questi visitano il sito stesso;',
          '<strong>cookie di funzionalità</strong>, che permettono all\'utente la navigazione in funzione di una serie di criteri selezionati (ad esempio, la lingua, i prodotti selezionati per l\'acquisto) al fine di migliorare il servizio reso allo stesso.'
        ],
        notice: '<strong>Per l\'installazione di tali cookie non è richiesto il preventivo consenso degli utenti.</strong>'
      },
      profiling: {
        title: 'Cookies di profilazione',
        p1: 'Sono volti a creare profili relativi all\'utente e vengono utilizzati al fine di inviare messaggi pubblicitari in linea con le preferenze manifestate dallo stesso nell\'ambito della navigazione in rete. In ragione della particolare invasività che tali dispositivi possono avere nell\'ambito della sfera privata degli utenti, la normativa europea e italiana prevede che l\'utente debba essere adeguatamente informato sull\'uso degli stessi ed esprimere così il proprio valido consenso.',
        list: [
          '<strong>pubblicitari</strong>: sono i cookie utilizzati per tracciare la navigazione dell\'utente in rete e creare profili sui suoi gusti, abitudini, scelte, ecc.',
          '<strong>comportamentali</strong>: sono i cookies utilizzati per raccogliere dati sulle abitudini di navigazione e sulle preferenze.'
        ],
        notice: '<strong>Per l\'installazione di tali cookie è richiesto il preventivo consenso degli utenti.</strong>'
      }
    },
    parties: {
      title: 'Tipologie di cookies in base ai soggetti coinvolti',
      list: [
        '<strong>Cookies del gestore del sito:</strong> se i cookies sono installati dal titolare del sito.',
        '<strong>Cookies di terze parti:</strong> se i cookies sono installati da soggetti diversi dal titolare del sito.'
      ]
    },
    duration: {
      title: 'Tipologie di cookies in base alla durata',
      list: [
        '<strong>Cookies di sessione:</strong> si cancellano automaticamente alla fine di ogni navigazione;',
        '<strong>Cookies persistenti:</strong> la loro durata è fissata dal server al momento della loro creazione.'
      ]
    },
    manage: {
      title: 'Come abilitare/disabilitare i cookie tramite il browser',
      p1: 'È possibile accettare o rifiutare i cookie o decidere di ricevere un messaggio di avviso prima di accettare un cookie dai siti Web visitati modificando le impostazioni del browser. Disabilitando completamente i cookie nel browser il nostro sito potrebbe non rispondere nello stesso modo.',
      p2: 'Si possono eliminare tutti i cookie installati nella cartella dei cookie del browser. Ciascun browser presenta procedure diverse per la gestione delle impostazioni:',
      browsers: ['Microsoft Edge', 'Google Chrome', 'Mozilla Firefox', 'Apple Safari'],
      blockTitle: 'Blocco dei cookie di terze parti',
      blockText: 'I cookie di terze parti non sono generalmente indispensabili per navigare, può rifiutarli di default attraverso apposite funzioni del browser.',
      dntTitle: 'Opzione Do Not Track',
      dntText: "L'opzione Do Not Track è presente nella maggior parte dei browser. I siti web progettati in modo da rispettare questa opzione dovrebbero automaticamente smettere di raccogliere alcuni tuoi dati di navigazione.",
      privateTitle: 'Attivare la modalità di "navigazione anonima"',
      privateText: 'Mediante questa funzione si può navigare senza lasciare traccia nel browser dei dati di navigazione. La funzione navigazione anonima non garantisce comunque l\'anonimato su Internet.'
    },
    table: {
      title: 'www.allmx.it utilizza i seguenti cookie o servizi',
      head: ['Nome cookie', 'Descrizione cookie', 'Tipologia', 'Gestione'],
      rows: [
        ['cookie di funzionalità', 'cookie per fornire servizi o migliorare la navigazione, quali la scelta della lingua e la compilazione di moduli nel sito.', 'Tecnico', 'Interna'],
        ['cookie di sessione', 'cookie di sessione che non consentono l\'acquisizione di dati personali identificativi e si cancellano automaticamente alla fine di ogni navigazione', 'Tecnico', 'Interna'],
        ['Google Analytics - dati anonimi', 'Google Analytics con impostazioni di dati anonimi, raccoglie informazioni su come utilizzi il nostro sito web. Questi cookie sono anonimi e vengono utilizzati solo per migliorare il funzionamento del sito.', 'Tecnico', 'Interna'],
        ['Cookie di Social Network', 'Necessari per permettere al tuo account social di interagire con il nostro sito (es. condividere contenuti). Non sono necessari alla navigazione.', 'Terze parti', 'Esterna']
      ]
    },
    contact: {
      title: 'Per ulteriori informazioni:',
      tel: 'Tel'
    }
  },
  en: {
    pageTitle: 'Cookie Policy - ALLMX',
    pageDesc: 'Cookie Policy for ALLMX.it',
    back: 'Back',
    title: 'Cookie Management',
    subtitle: 'Information on the use of cookies',
    lastUpdate: 'Last updated',
    locale: 'en-US',
    intro: {
      greeting: 'Dear visitor,',
      text: 'This website provides you with information about the cookies it manages on <strong>www.allmx.it</strong>, in compliance with the ePrivacy Directive 2009/136/EC, Directive 2002/58/EC on the processing of personal data in the electronic communications sector, and the general provision of May 8, 2014 by the Italian Data Protection Authority.'
    },
    what: {
      title: 'What are cookies',
      p1: 'Cookies are small text files that websites send to users\' devices, generally stored in the browser directory and transmitted back to the websites on subsequent visits. They allow the website operator to do useful things — for example, improve the browsing experience and the functioning of the site, making interactions faster and more personalized, and allow the operator to know whether a computer has visited the site before or to store items in the shopping cart on e-commerce sites.',
      p2: 'A cookie is not personal in nature, but it may be linked to personal information; in this case, consent for its use is required.'
    },
    purpose: {
      title: 'Types of cookies by purpose',
      technical: {
        title: 'Technical cookies',
        p1: 'These are used solely "to carry out the transmission of a communication on an electronic communications network, or as strictly necessary for the provider of an information society service explicitly requested by the subscriber or user to provide that service".',
        p2: 'They are not used for any other purpose and are normally installed directly by the website owner. They can be divided into:',
        list: [
          '<strong>Navigation or session cookies</strong>, which ensure normal navigation and use of the website; they are not stored persistently on the user\'s computer and disappear when the browser is closed;',
          '<strong>Analytics cookies</strong>, treated as technical cookies when used directly by the site operator to collect information in aggregate form about the number of users and how they visit the site;',
          '<strong>Functionality cookies</strong>, which allow the user to browse based on selected criteria (e.g. language, products selected for purchase) in order to improve the service provided to them.'
        ],
        notice: '<strong>The installation of these cookies does not require prior user consent.</strong>'
      },
      profiling: {
        title: 'Profiling cookies',
        p1: 'These are intended to create user profiles and are used to send advertising messages in line with the preferences expressed by the user during online browsing. Due to the particular intrusiveness of these devices into the private sphere of users, European and Italian law requires that the user be adequately informed about their use and express valid consent.',
        list: [
          '<strong>Advertising cookies</strong>: used to track the user\'s browsing and create profiles about tastes, habits, choices, etc.',
          '<strong>Behavioral cookies</strong>: used to collect data on browsing habits and preferences for market research or remote sales.'
        ],
        notice: '<strong>The installation of these cookies requires prior user consent.</strong>'
      }
    },
    parties: {
      title: 'Types of cookies by parties involved',
      list: [
        '<strong>First-party cookies:</strong> when cookies are installed by the website owner.',
        '<strong>Third-party cookies:</strong> when cookies are installed by parties other than the website owner.'
      ]
    },
    duration: {
      title: 'Types of cookies by duration',
      list: [
        '<strong>Session cookies:</strong> automatically deleted at the end of each browsing session;',
        '<strong>Persistent cookies:</strong> their duration is set by the server at the time of their creation.'
      ]
    },
    manage: {
      title: 'How to enable/disable cookies via your browser',
      p1: 'You can accept or refuse cookies, or choose to be notified before accepting a cookie from a website by modifying your browser settings. By completely disabling cookies in your browser, our website may not work in the same way.',
      p2: 'You can delete all cookies installed in your browser\'s cookie folder. Each browser has different procedures for managing settings:',
      browsers: ['Microsoft Edge', 'Google Chrome', 'Mozilla Firefox', 'Apple Safari'],
      blockTitle: 'Blocking third-party cookies',
      blockText: 'Third-party cookies are generally not essential for browsing; you can refuse them by default through specific browser functions.',
      dntTitle: 'Do Not Track option',
      dntText: 'The Do Not Track option is present in most browsers. Websites designed to respect this option should automatically stop collecting some of your browsing data when it is enabled.',
      privateTitle: 'Enabling "private browsing" mode',
      privateText: 'This function allows you to browse without leaving traces of your browsing data in your browser. Private browsing does not, however, guarantee anonymity on the Internet.'
    },
    table: {
      title: 'www.allmx.it uses the following cookies or services',
      head: ['Cookie name', 'Description', 'Type', 'Management'],
      rows: [
        ['Functionality cookies', 'cookies to provide services or improve navigation, such as language selection and form filling on the site.', 'Technical', 'Internal'],
        ['Session cookies', 'session cookies that do not allow the acquisition of personally identifiable data and are automatically deleted at the end of each session', 'Technical', 'Internal'],
        ['Google Analytics — anonymous data', 'Google Analytics with anonymous data settings; collects information about how you use our website. These cookies are anonymous and are used only to help us improve the operation of our site.', 'Technical', 'Internal'],
        ['Social Network cookies', 'Required to allow your social account to interact with our site (e.g. sharing content). They are not necessary for browsing.', 'Third-party', 'External']
      ]
    },
    contact: {
      title: 'For more information:',
      tel: 'Phone'
    }
  }
};

const CookiePolicy = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  // For ES (and any other unsupported locale), fall back to Italian text — same
  // approach used in the other legal pages (the body of legal documents stays
  // in the original Italian as advised by the user).
  const c = CONTENT[language] || CONTENT.it;

  return (
    <div className="dark-container pt-20 min-h-screen">
      <SEO title={c.pageTitle} description={c.pageDesc} url="https://allmx.it/cookie-policy" />
      <div className="max-w-4xl mx-auto px-6 py-12">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-white/70 hover:text-white mb-8 transition-colors"
          data-testid="cookie-back-btn"
        >
          <ArrowLeft size={20} />
          {c.back}
        </button>

        <h1 className="text-4xl sm:text-5xl font-bold mb-4">{c.title}</h1>
        <p className="text-xl text-white/70 mb-2">{c.subtitle}</p>
        <p className="text-sm text-white/50 mb-12">
          {c.lastUpdate}: {new Date().toLocaleDateString(c.locale)}
        </p>

        {/* Introduction */}
        <div className="dark-card p-6 mb-8">
          <p className="text-xl font-semibold mb-4">{c.intro.greeting}</p>
          <p className="leading-relaxed" dangerouslySetInnerHTML={{ __html: c.intro.text }} />
        </div>

        {/* What are cookies */}
        <section className="dark-card p-6 mb-8">
          <h2 className="text-2xl font-bold mb-4 text-primary">{c.what.title}</h2>
          <p className="leading-relaxed mb-4">{c.what.p1}</p>
          <p className="leading-relaxed">{c.what.p2}</p>
        </section>

        {/* Purpose */}
        <section className="dark-card p-6 mb-8">
          <h2 className="text-2xl font-bold mb-4 text-primary">{c.purpose.title}</h2>
          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-semibold mb-2 text-white">{c.purpose.technical.title}</h3>
              <p className="mb-2">{c.purpose.technical.p1}</p>
              <p className="mb-2">{c.purpose.technical.p2}</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                {c.purpose.technical.list.map((li, i) => (
                  <li key={`tch-${i}`} dangerouslySetInnerHTML={{ __html: li }} />
                ))}
              </ul>
              <p className="mt-2" dangerouslySetInnerHTML={{ __html: c.purpose.technical.notice }} />
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-2 text-white">{c.purpose.profiling.title}</h3>
              <p className="mb-2">{c.purpose.profiling.p1}</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                {c.purpose.profiling.list.map((li, i) => (
                  <li key={`prf-${i}`} dangerouslySetInnerHTML={{ __html: li }} />
                ))}
              </ul>
              <p className="mt-2" dangerouslySetInnerHTML={{ __html: c.purpose.profiling.notice }} />
            </div>
          </div>
        </section>

        {/* Parties */}
        <section className="dark-card p-6 mb-8">
          <h2 className="text-2xl font-bold mb-4 text-primary">{c.parties.title}</h2>
          <ul className="space-y-3">
            {c.parties.list.map((li, i) => (
              <li key={`pt-${i}`} dangerouslySetInnerHTML={{ __html: li }} />
            ))}
          </ul>
        </section>

        {/* Duration */}
        <section className="dark-card p-6 mb-8">
          <h2 className="text-2xl font-bold mb-4 text-primary">{c.duration.title}</h2>
          <ul className="space-y-3">
            {c.duration.list.map((li, i) => (
              <li key={`dr-${i}`} dangerouslySetInnerHTML={{ __html: li }} />
            ))}
          </ul>
        </section>

        {/* Manage cookies */}
        <section className="dark-card p-6 mb-8">
          <h2 className="text-2xl font-bold mb-4 text-primary">{c.manage.title}</h2>
          <p className="mb-4">{c.manage.p1}</p>
          <p className="mb-4">{c.manage.p2}</p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            {c.manage.browsers.map((b, i) => (
              <li key={`br-${i}`}>{b}</li>
            ))}
          </ul>

          <h3 className="text-lg font-semibold mt-6 mb-2">{c.manage.blockTitle}</h3>
          <p className="mb-4">{c.manage.blockText}</p>

          <h3 className="text-lg font-semibold mt-6 mb-2">{c.manage.dntTitle}</h3>
          <p className="mb-4">{c.manage.dntText}</p>

          <h3 className="text-lg font-semibold mt-6 mb-2">{c.manage.privateTitle}</h3>
          <p>{c.manage.privateText}</p>
        </section>

        {/* Table */}
        <section className="dark-card p-6 mb-8">
          <h2 className="text-2xl font-bold mb-4 text-primary">{c.table.title}</h2>
          <div className="overflow-x-auto">
            <table className="w-full text-sm border-collapse">
              <thead>
                <tr className="border-b border-white/20">
                  {c.table.head.map((h, i) => (
                    <th key={`th-${i}`} className="text-left py-3 px-3 font-semibold">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {c.table.rows.map((row, ri) => (
                  <tr key={`row-${ri}`} className="border-b border-white/10">
                    {row.map((cell, ci) => (
                      <td key={`cell-${ri}-${ci}`} className="py-3 px-3">{cell}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* Contact */}
        <div className="dark-card p-6 bg-primary/10 border-l-4 border-primary">
          <p className="font-semibold mb-2">{c.contact.title}</p>
          <p><strong>Ala S.r.l.</strong></p>
          <p>Via Umberto Giordano, 84 - 90144 Palermo</p>
          <p>{c.contact.tel}: 091226476</p>
          <p>Email: ala@crosshop.it</p>
          <p>PEC: alasrlpalermo@pec.it</p>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
